/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import ParticipantDetailsChangeContainer from './participant.details.change.container';

class ParticipantDetailsChangeModal extends React.Component {
  render() {
    return (
      <div id="participant-journey-modal">
        <ParticipantDetailsChangeContainer />
      </div>
    );
  }
}

export default ParticipantDetailsChangeModal;
